import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import * as styles from "./Grid.module.scss";

const GridCustomColumns = {
	md3Lg5: "md3Lg5",
	md3Lg6: "md3Lg6",
};

const Row = ({ className, customCols, cols, gap, children }) => (
	<div
		data-cols={cols || customCols}
		style={{ "--_grid-cols": cols }}
		className={cx(styles.grid, className, {
			[styles.gridNoGap]: !gap,
			[styles[customCols]]: customCols,
		})}>
		{children}
	</div>
);

Row.displayName = "Row";

const Cell = ({ className, children, cellNormal }) => (
	<div className={cx(styles.gridItem, className, cellNormal ? styles.gridItemNormal : undefined)}>
		{children}
	</div>
);

Cell.displayName = "Cell";

Row.propTypes = {
	className: PropTypes.string,
	cols: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
	children: PropTypes.node.isRequired,
	gap: PropTypes.bool,
	customCols: PropTypes.oneOf(Object.values(GridCustomColumns)),
};

Row.defaultProps = {
	className: undefined,
	cols: 1,
	gap: true,
	customCols: undefined,
};

Cell.propTypes = {
	className: PropTypes.string,
	children: PropTypes.node.isRequired,
	cellNormal: PropTypes.bool,
};

Cell.defaultProps = {
	className: undefined,
	cellNormal: false,
};

export { Row, Cell, GridCustomColumns };
